import React, { useState } from "react";
import CustomButton from "../Button/CustomButton";
import { Box, Modal, Typography } from "@mui/material";
import CustomInput from "../input/CustomInput";
const OTPmodal = ({ Open, confirmUpdate, modalID }) => {
  const [otp, setOtp] = useState("");

  const handleUpdate = (status, modalID, otp) => {
    let id = modalID;
    confirmUpdate(status, id, otp);
  };
  return (
    <Box>
      <Modal open={Open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            outline: "none",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "20px",
          }}
        >
          <Typography
            sx={{ fontFamily: "Inter", fontSize: "25px", fontWeight: 500 }}
          >
            Enter OTP
          </Typography>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "start",
            }}
          >
            <CustomInput
              sx={{ width: "100%", bgcolor: "#F8F8F8", mt: 1 }}
              onChange={(e) => setOtp(e.target.value)}
              maxLength={7}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 5,
              mt: 2,
            }}
          >
            <CustomButton
              sx={{
                bgcolor: "#31AEF4",
                height: "50px",
                "&:hover": {
                  bgcolor: "#31AEF4",
                },
              }}
              onClick={() => handleUpdate(2, modalID, otp)}
            >
              Confirm
            </CustomButton>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default OTPmodal;
